import(/* webpackMode: "eager" */ "/vercel/path0/src/app/book-appointment/page.jsx");
